import { render, staticRenderFns } from "./RegionsCreate.vue?vue&type=template&id=7ab16c07&"
import script from "./RegionsCreate.vue?vue&type=script&lang=js&"
export * from "./RegionsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports